export default "__VITE_ASSET__d4ce9020__"